const React = require('react');
const InfoBox = require('./infobox.jsx').InfoBox;
const DateTimeUtils = require('./utils/datetime').Utils;
const HeaderMixin = require('./mixins/header').HeaderMixin;
const env = require('./utils/env').env;

let Availability = React.createClass({

    mixins: [HeaderMixin],

	getLines: function(text) {
		if (!text) return '';

		text = text.replace(/(\r\n|\r)/g,"\n");
        return text.split("\n");
	},

    getProductSpecs: function() {
        let fields = this.getProductFields();
        let str = '';
        for(let field in fields) {
            if (this.props[field])
                str += fields[field] + ', ';
        }
        if (str.length > 0)
            str = str.slice(0,-2);
        return str;
    },


    render: function() {
        let lines = this.getLines(this.props.Content) || [];
        let renderedLines = [];
        let i = 0;

        lines.forEach(function(line) {
            renderedLines.push(<div key={i}>{line.length?line:' '}</div>);
            i++;
        });
        const productSpecs = this.getProductSpecs();
        let mailto = this.getFarmerMailTo();
     	return (
 			<main className="content white">
                <div className="info-boxes">
                    <InfoBox title="" content={this.props.PublishDate?DateTimeUtils.formatLongDate(this.props.PublishDate):''} bottom={DateTimeUtils.formatTime(this.props.PublishDate)} colorClass="fresh" />
                    <div className="notes">{productSpecs}</div>
                    <div className="notes">{this.props.Notes}</div>
                </div>
 				<div className="availability-wrapper">
                    <div className="availability-white-box">
                        <div className="heading">
                            <h4>Availability</h4>
                        </div>
                        <div className="lines">
                            {renderedLines}
                        </div>
                        {this.props.children}
                        <br/>
                        {this.props.Location.ContactEmail?<div>
                            <a href={mailto}>Request Information</a>
                        </div>
                                :""}
                    </div>
                </div>
			</main>
		)
    }
});

exports.Availability = Availability;